import { render, staticRenderFns } from "./SwitchField.vue?vue&type=template&id=fa0943e8&scoped=true&"
import script from "./SwitchField.vue?vue&type=script&lang=js&"
export * from "./SwitchField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchField.vue?vue&type=style&index=0&id=fa0943e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0943e8",
  null
  
)

export default component.exports